import React from 'react';

export default function Footer() {
  return(
    <>
    <footer className="container-fluid rodape">
      <div className="col-lg-6">
          <span>AGÊNCIA GUPPY | 21 2143-0619</span>
      </div>
      <div className="col-lg-6 text-right">
          <a href="mailto:contato@agenciaguppy.com.br">contato@agenciaguppy.com.br</a>
      </div>
    </footer>
    </>
  )
}
